/**
 * El alto de un elemento, al día: lo mide al montarse y cada vez que cambia
 * (`ResizeObserver`). Devuelve una ref de función —así sigue midiendo aunque el
 * elemento aparezca o desaparezca entre renders— y el alto en píxeles, o null
 * mientras no haya nada que medir.
 */
import { useCallback, useEffect, useState } from 'react';

export function useAltoObservado<T extends HTMLElement>(): [(elemento: T | null) => void, number | null] {
  const [elemento, setElemento] = useState<T | null>(null);
  const [alto, setAlto] = useState<number | null>(null);

  useEffect(() => {
    if (elemento === null) {
      setAlto(null);
      return;
    }

    const observador = new ResizeObserver(([entrada]) => {
      if (entrada !== undefined) setAlto(Math.round(entrada.borderBoxSize[0]?.blockSize ?? 0));
    });
    observador.observe(elemento);
    return () => {
      observador.disconnect();
    };
  }, [elemento]);

  const ref = useCallback((nuevo: T | null) => {
    setElemento(nuevo);
  }, []);

  return [ref, alto];
}
